import React from 'react'
import PlanWrapper from '../../Common/PlanWrapper'

const WellnessPlansWrapper = () => <PlanWrapper planType='wellness' planLabel='Wellness Plans' isMonitoring={true} />

export default WellnessPlansWrapper
